var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99989 10.1701L2.52989 6.70007C2.13989 6.31007 1.50989 6.31007 1.11989 6.70007C0.729893 7.09007 0.729893 7.72007 1.11989 8.11007L5.29989 12.2901C5.68989 12.6801 6.31989 12.6801 6.70989 12.2901L17.2899 1.71007C17.6799 1.32007 17.6799 0.690068 17.2899 0.300068C16.8999 -0.0899316 16.2699 -0.0899316 15.8799 0.300068L5.99989 10.1701Z",
    fill: "#E26C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTick);
export default __webpack_public_path__ + "static/media/red-tick.56415e3f1c0932c7377851930b8b8f76.svg";
export { ForwardRef as ReactComponent };